<template>
  <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile" style="border: .08em solid #eee">
    <p class="card-dados__titulo mb-0" style="font-weight: 600; color: #777; background-color: #cfcfcf; padding: 0.6rem 0.8rem;">Linhas de Fornecimento do Processo</p>

    <v-data-table :headers="colunas" :items="value"
                  no-data-text="Não há linhas de fornecimento adicionadas"
                  class="az-table-list tabela-linha">
      <template slot="items" slot-scope="props">
        <td>
          {{props.item.linhaFornecimentoCodigo}} - {{props.item.linhaFornecimentoDescricao}}
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
export default {
    name: 'PainelLinhaFornecimentoVisualizacao',
    props: {
        value: {
            required: true
        }
    },
    data() {
        return {
            colunas: [
                {
                    text: 'Linha de Fornecimento',
                    value: 'linhaFornecimentoCodigo',
                    sortable: true,
                    align: 'left',
                    width: '100%',
                    class: 'primary--text'
                }
            ]
        }
    }
}
</script>

<style scoped>
.tabela-linha {
    padding: 16px;
}

@media (max-width: 720px) {
    .tabela-linha {
        padding: 0;
    }
}
</style>